/**
 * Subscription Configuration (Frontend)
 *
 * Centralized configuration for subscription-related constants.
 * This ensures consistency across the frontend application.
 *
 * NOTE: Keep in sync with backend/config/subscription.js
 */

export const SUBSCRIPTION_CONFIG = {
  // Trial period in days
  TRIAL_PERIOD_DAYS: 7,

  // Pricing
  PERSONAL_PLAN_PRICE: 49, // in euros
  PERSONAL_PLAN_CURRENCY: 'EUR',
  PERSONAL_PLAN_INTERVAL: 'month',

  // Plan names
  PLANS: {
    PERSONAL: 'personal',
    ENTERPRISE: 'enterprise',
  },

  // Subscription statuses (matching Stripe)
  STATUS: {
    TRIALING: 'trialing',
    ACTIVE: 'active',
    PAST_DUE: 'past_due',
    CANCELED: 'canceled',
    INCOMPLETE: 'incomplete',
    INCOMPLETE_EXPIRED: 'incomplete_expired',
    UNPAID: 'unpaid',
    PAUSED: 'paused',
  },

  // Trial warning thresholds
  TRIAL_WARNING_DAYS: 3, // Show warning when 3 or fewer days remain
};

export default SUBSCRIPTION_CONFIG;
